export const PATIENT_STATUS = [
	{
		value: false,
		name: "Đang điều trị",
	},
	{
		value: true,
		name: "Đã kết thúc điều trị",
	},
];
